<h1>Piece Rate Entry Form</h1>
<p-tabMenu [model]="items" [activeItem]="activeItem">
  <ng-template pTemplate="item" let-item let-i="index">
    <div style="position: relative; text-align: center; min-width: 10em">
      <div class="ui-menuitem-text">
        {{item.label}}
      </div>
    </div>
  </ng-template>
</p-tabMenu>
<div class="p-grid" *ngIf="visible && adjustmentObj; else notVisible">
  <div class="p-col-12 p-md-8 p-xl-9">
    <app-piece-rate-group-totals [activity]="activity"></app-piece-rate-group-totals>
    <app-piece-rate-entries [activity]="activity"></app-piece-rate-entries>
  </div>
  <div class="p-col-12 p-md-4 p-xl-3 sticky">
    <div *ngIf="activeItem; else notConfigured">
      <app-piece-rate-summary *ngIf="adjustmentCalculationActive" [activity]="activity"></app-piece-rate-summary>
      <app-piece-rate-reset [activity]="activity"></app-piece-rate-reset>
      <app-piece-rate-week-status [activity]="activity"></app-piece-rate-week-status>
      <app-piece-rate-adjustment-calculation [showAdjustmentOption]="adjustmentCalculationActive" [activity]="activity"></app-piece-rate-adjustment-calculation>
    </div>
    <ng-template #notConfigured>
      <p-card>
        <p>This site has not been configured for Piece Rate Entry.</p>
      </p-card>
    </ng-template>
  </div>
</div>
<ng-template #notVisible>
  <p-card>
    <p>Could not open Piece Rate Adjustment.</p>
  </p-card>
</ng-template>

<p-dialog [(visible)]="showOpenDialog" header="Initialize Piece Rate Entries" showEffect="fade" [modal]="true" appendTo="body">
  <p>There are no Piece Rate entries opened for {{shiftContext?.date | dateTimeToFormat:'M/dd/yyyy' }} s{{shiftContext?.shiftNum}}. Do you wish to create them?</p>

  <div class="form-buttons">
    <button pButton type="button"
      label="Cancel"
      class="p-button-secondary"
      (click)="closeOpenDialog()">
    </button>
    <button pButton type="button"
      label="Create Entries"
      icon="pi pi-plus"
      class="p-button-success"
      (click)="initializeAdjustment()">
    </button>
  </div>
</p-dialog>
